import auth from "../../middlewares/auth";
export const examManagementRoute = [
  {
    path: '/exam-management/exams',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/exam_management/exams/ExamList'),
    name: 'exam_management_exams',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/exam-management/exam/add',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/exam_management/exams/ExamForm'),
    name: 'exam_management_exam_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/exam-management/exam/edit/:id',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/exam_management/exams/ExamForm'),
    name: 'exam_management_exam_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];